<template>
    <div class="pop-page">
        <div class="pop-box">
            <img src="../assets/imgs/logo_opacity.png" alt="logo">
            <div class="pop-text">{{$t('home.commingSoon')}}</div>
            <div class="pop-btn" @click="back">{{$t('home.back')}}</div>
        </div>
    </div>
</template>

<script>
  export default {
    data() {
      return {
      };
    },
    methods:{
        back(){
            this.$emit('back')
        }
    },
  };
</script>

<style lang="scss" scoped>
    .pop-page{
        .pop-box{
            position: fixed;
            top: calc(50vh - 236px);
            left: calc(50% - 315px);
            width: 630px;
            height: 472px;
            background: #FFFFFF;
            box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.14);
            border-radius: 37px;
            z-index: 1000;
            overflow: hidden;
            img{
                width: 485px;
                height: 488px;
                position: absolute;
                top: -16px;
                right: -80px;
                z-index: -1;
            }
            .pop-text{
                width: 100%;
                text-align: center;
                color: #000;
                font-family: 'K2D';
                font-style: normal;
                font-weight: 800;
                font-size: 76px;
                line-height: 84px;
                margin-top: 113px;
            }
            .pop-btn{
                width: 167px;
                height: 70px;
                text-align: center;
                line-height: 70px;
                font-family: 'K2D';
                font-style: italic;
                font-weight: 800;
                font-size: 32px;
                background: #EA4344;
                border-radius: 18px;
                margin: 0 auto;
                margin-top: 103px;
                cursor: pointer;
            }
        }
    }
</style>